import { Box, Typography } from "@mui/material"

const sortAssets = (assets, investByDate, guidanceMap) => {
	if (investByDate) {
		return [...assets].sort((a, b) => {
			const da = guidanceMap[a.identificator]?.lastPurchaseDate ?? null
			const db = guidanceMap[b.identificator]?.lastPurchaseDate ?? null
			if (da === null && db === null) return 0
			if (da === null) return -1
			if (db === null) return 1
			return new Date(da) - new Date(db)
		})
	}
	return [...assets].sort((a, b) => a.diff - b.diff)
}

const NextAssetCard = ({ allocations = [], portfolio = [], guidanceMap = {}, investByDate = false }) => {
	const nextAllocation = allocations
		.filter(item => typeof item.current !== 'undefined' && typeof item.planned !== 'undefined' && item.planned !== 0)
		.map(item => ({
			...item,
			diff: (Number(item.current) || 0) - (Number(item.planned) || 0)
		}))
		.sort((a, b) => a.diff - b.diff)[0];

	let nextTicker = null;
	if (nextAllocation) {
		const assets = portfolio
			.filter(p => p.assetType === nextAllocation.assetType && p.target && Number(p.target) > 0)
			.map(p => ({
				...p,
				diff: (Number(p.percentage) || 0) - (Number(p.target) || 0)
			}))
		nextTicker = sortAssets(assets, investByDate, guidanceMap)[0]
	}

	const diffColor = (value) => value > 0 ? 'success.main' : value < 0 ? 'error.main' : 'text.secondary';
	const renderDiff = (value) => `${value >= 0 ? '+' : ''}${value.toFixed(2)}%`;

	return (
		<Box sx={{ width: '100%' }}>
			<Typography variant="h6" gutterBottom>Próximo ativo a aportar</Typography>
			<Typography variant="body2" color="text.secondary">
				{investByDate
					? 'Ativo sem aporte há mais tempo (ativos nunca aportados têm prioridade).'
					: 'Ativo mais distante do alvo (menor diferença atual - alvo).'}
			</Typography>
			<Box
				marginTop={2}
				sx={{
					border: '1px dashed #bdbdbd',
					borderRadius: 2,
					padding: 2,
					bgcolor: '#fafafa'
				}}
			>
				{nextAllocation ? (
					<>
						<Typography variant="subtitle2" color="primary">{nextAllocation.label}</Typography>
						<Typography variant="body2">
							Dif. atual vs alvo:{' '}
							<Box component="span" sx={{ color: diffColor(nextAllocation.diff), fontWeight: 600 }}>
								{renderDiff(nextAllocation.diff)}
							</Box>
						</Typography>
						<Typography variant="body2" color="text.secondary">
							Atual: {nextAllocation.current}% • Alvo: {nextAllocation.planned}%
						</Typography>
						{nextTicker ? (
							<Box marginTop={2} padding={1} borderRadius={1} border="1px solid #e0e0e0" bgcolor="#f5f5f5">
								<Typography variant="subtitle1" color="primary" fontWeight={700}>
									Aportar em: {nextTicker.identificator || nextTicker.stockTicker} &nbsp;
									<Box component="span" sx={{ color: diffColor(nextTicker.diff || 0), fontWeight: 600 }}>
										({renderDiff(nextTicker.diff || 0)})
									</Box>
								</Typography>
								<Typography variant="body2" marginTop={0.5}>
									Atual: {(nextTicker.percentage || 0).toFixed(2)}% • Alvo: {nextTicker.target}%
								</Typography>
							</Box>
						) : (
							<Typography variant="caption" color="text.secondary">Nenhum ticker com target definido neste segmento.</Typography>
						)}
					</>
				) : (
					<Typography variant="body2" color="text.secondary">Sem dados de alocação.</Typography>
				)}
			</Box>
		</Box>
	)
}

export default NextAssetCard
